import { enviroments } from '@infrastructure/enviroments';
import { base } from '@service/base';

const BANNER_MS_BASE_URL = enviroments.BASE_URL;

interface PutProgramsBySegmentRelationParams {
  values: Array<{ idProgram: number }>;
  segmentId: string;
}
export async function putProgramsBySegmentRelation({
  values,
  segmentId,
}: PutProgramsBySegmentRelationParams): Promise<void> {
  const { data } = await base({
    baseURL: BANNER_MS_BASE_URL,
    url: `/programs/relations/by-segment-id/${segmentId}`,
    method: 'PUT',
    data: values,
  });

  return data;
}
